module.exports = __webpack_public_path__ + "static/img/paint.9336508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paint.png
// module id = /w/3
// module chunks = 0